import HiddenFormItem from '@/components/HiddenFormItem';
import { setUser } from '@/redux/reducer';
import { Iuser, RootState } from '@/typings';
import {
	ElButton,
	ElCheckbox,
	ElDialog,
	ElForm,
	ElInput,
	ElLink,
	ElLoading,
	ElMessage,
	ElUpload,
	FormRules,
	isEmpty,
	isNotEmpty,
	useClassNames,
	useForm,
} from '@qsxy/element-plus-react';
import classNames from 'classnames';
import 'cropperjs/dist/cropper.css';
import { useEffect, useMemo, useState } from 'react';
import { Cropper } from 'react-cropper';
import { useDispatch, useSelector } from 'react-redux';
import { saveUser } from './api';

const UserInfo = () => {
	const dispatch = useDispatch();
	const loginUser = useSelector<RootState, RootState['user']>(state => state.user);

	const [formInstance] = useForm<Iuser>();

	const { b } = useClassNames('setting', 'ttn');
	const [visible, setVisible] = useState(false);
	const [image, setImage] = useState();
	const [cropper, setCropper] = useState<any>();

	useEffect(() => {
		formInstance.setFieldsValue(loginUser);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loginUser]);

	const rules = useMemo<FormRules>(() => {
		return {
			name: [{ required: true, message: '用户姓名不可为空' }],
			mobile: [
				{
					len: 11,
					message: '请填写11位长度的手机号码',
				},
				{
					pattern: /^1((3\d)|(4[578])|(5[0-3,5-9])|(6[67])|(7[1-3,5-8])|(8\d)|(9[013,5-9])|(44))\d{8}$/,
					message: '请正确填写您的手机号码',
				},
			],
			email: [
				{
					type: 'email',
					message: '请正确填写您的邮箱地址',
				},
			],
		};
	}, []);

	return (
		<>
			<h3 className="title">个人信息</h3>
			<section className={b()}>
				<aside className={classNames(b`aside`, b`aside-left`)}>
					<span className={b`avatar`} onClick={() => setVisible(true)}>
						<img src={loginUser?.avatar} style={{ width: '100%' }} />
					</span>
					<ElLink onClick={() => setVisible(true)}>点击修改头像</ElLink>
				</aside>
				<main className={b`main`}>
					<ElForm form={formInstance} colon labelWidth={120} style={{ marginTop: 20, maxWidth: 500 }} rules={rules}>
						<HiddenFormItem name="id" />

						<ElForm.Item label="登录账号" name="username">
							<ElInput plain readOnly clearable={false} />
						</ElForm.Item>

						<ElForm.Item label="公司名称" name="company">
							<ElInput />
						</ElForm.Item>

						<ElForm.Item label="职位" name="job">
							<ElInput />
						</ElForm.Item>

						<ElForm.Item label="手机号" name="phoneNumber">
							<ElInput />
						</ElForm.Item>

						<ElForm.Item label="邮箱" name="email">
							<ElInput />
						</ElForm.Item>

						<ElForm.Item label="是否绑定微信" name="wechatId">
							{value => <ElCheckbox checked={isNotEmpty(value)} disabled />}
						</ElForm.Item>

						<ElForm.Item>
							<ElButton
								type="primary"
								onClick={() => {
									formInstance.validateFields().then(user => {
										const load = ElLoading.service({ text: '正在保存中，请稍后...' });
										saveUser(user)
											.then(() => {
												load.close();
												dispatch(setUser({ ...loginUser, ...user }));
												ElMessage.success('保存成功！');
											})
											.catch(() => {
												load.close();
												ElMessage.error('保存失败！');
											});
									});
								}}
							>
								保存信息
							</ElButton>
						</ElForm.Item>
					</ElForm>
				</main>
			</section>

			<ElDialog visible={visible} width="600px" title="选择头像" close={() => setVisible(false)} onLeave={() => setImage(null)}>
				<ElDialog.body>
					<div className={b`content`}>
						<div className={classNames(b`canvas`, { 'cropper-bg': isEmpty(image) })}>
							<Cropper
								style={{ height: 400, width: '100%' }}
								// zoomTo={1}
								initialAspectRatio={1}
								preview=".img-preview"
								dragMode="move"
								src={image}
								viewMode={0}
								minCropBoxHeight={40}
								minCropBoxWidth={40}
								background
								responsive
								highlight
								aspectRatio={1}
								// cropBoxResizable={false}
								wheelZoomRatio={0.3}
								autoCropArea={0.625}
								checkOrientation={false}
								onInitialized={instance => {
									setCropper(instance);
								}}
								guides
							/>
						</div>
						<div className={b`view`}>
							<div className="preview img-preview"></div>
						</div>
					</div>
				</ElDialog.body>
				<ElDialog.footer>
					<section className={b()}>
						<aside className={classNames(b`aside`, b`aside-left__footer`)}>
							<ElUpload
								action="#"
								autoUpload={false}
								showFileList={false}
								onChange={uploadFile => {
									const reader = new FileReader();
									reader.onload = () => {
										setImage(reader.result as any);
									};
									reader.readAsDataURL(uploadFile.raw);
								}}
							>
								<ElButton icon="cloud-arrow-up">上传图片</ElButton>
							</ElUpload>
							<ElButton icon="arrows-rotate" onClick={() => cropper.reset()}>
								刷新
							</ElButton>
							<ElButton icon="arrow-rotate-left" onClick={() => cropper.rotate(-90)}>
								左转
							</ElButton>
							<ElButton icon="arrow-rotate-right" onClick={() => cropper.rotate(90)}>
								右转
							</ElButton>
						</aside>
						<main className={b`main`} style={{ textAlign: 'center' }}>
							<ElButton
								type="primary"
								onClick={() => {
									if (isNotEmpty(cropper?.getCroppedCanvas()?.toDataURL())) {
										const load = ElLoading.service({ text: '正在保存中，请稍后...' });
										saveUser({ username: loginUser.username, avatar: cropper.getCroppedCanvas().toDataURL() })
											.then(() => {
												dispatch(setUser({ ...loginUser, avatar: cropper.getCroppedCanvas().toDataURL() }));
												setImage(null);
												setVisible(false);
											})
											.catch(() => ElMessage.error('保存头像失败！'))
											.finally(() => load.close());
									} else {
										ElMessage.warning('请先上传图片！');
									}
								}}
							>
								保存图片
							</ElButton>
						</main>
					</section>
				</ElDialog.footer>
			</ElDialog>
		</>
	);
};

export default UserInfo;
